import { DEFAULT_COUNTRY_CODE } from "../../constants/countries";
import { MemberInfo } from "../../graphql/onboarding/member/types/MemberInfo";
import { UserInfo } from "../../graphql/onboarding/user/types/UserInfo";
import {
  CreateMemberInput,
  CreateUserInput,
} from "../../types/graphql-global-types-onboarding";

export const mappedMember = (member: UserInfo): CreateUserInput => {
  return {
    id: member?.id ?? "",
    firstname: member?.firstname ?? "",
    name: member?.name ?? "",
    sharesPercentage: member?.sharesPercentage ?? 0,
    countryIsoCode: member?.countryIsoCode ?? DEFAULT_COUNTRY_CODE,
    city: member?.city ?? "",
    postcode: member?.postcode ?? "",
    address: member?.address ?? "",
    nationalityCountryIsoCode:
      member?.nationalityCountryIsoCode ?? DEFAULT_COUNTRY_CODE,
    mobilePhoneNumber: member?.mobilePhoneNumber ?? "",
    gender: member?.gender ?? "",
    email: member?.email ?? "",
    isLegalRepresentative: member?.isLegalRepresentative ?? false,
    specifiedUSPerson: !!member?.id,
    cityOfBirth: member?.cityOfBirth ?? "",
    countryOfBirthIsoCode:
      member?.countryOfBirthIsoCode ?? DEFAULT_COUNTRY_CODE,
    dateOfBirth: member?.dateOfBirth ?? null,
    type: member?.type ?? "UBO",
    documents: member?.documents?.length
      ? member.documents.map((d) => ({
          base64Content: d?.base64Content,
          fileType: d?.fileType,
          filename: d?.filename,
          type: d?.type?.type,
        }))
      : undefined,
    isDirector: !!member.isDirector,
    directorAppointmentDate: member?.isDirector
      ? member.directorAppointmentDate
      : null,
  };
};
